import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { tokens } from '../../theme';

/** Compact overview metric panel */
export default function MetricCard({ label, value, detail, loading = false, action = null, children = null }) {
  return (
    <Box
      sx={{
        backgroundColor: tokens.surface,
        border: `1px solid ${tokens.border}`,
        borderRadius: 2,
        p: 2.25,
        minHeight: 118,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.75,
        height: '100%',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: tokens.inkMuted,
            fontWeight: 650,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
            fontSize: 11,
          }}
        >
          {label}
        </Typography>
        {action}
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <CircularProgress size={22} />
        </Box>
      ) : (
        <>
          <Typography
            sx={{
              fontFamily: "'Fraunces', 'Figtree', serif",
              fontWeight: 650,
              fontSize: 28,
              lineHeight: 1.15,
              color: tokens.accent,
              wordBreak: 'break-word',
            }}
          >
            {value}
          </Typography>
          {detail && (
            <Typography
              variant="body2"
              sx={{
                color: tokens.ink,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={typeof detail === 'string' ? detail : undefined}
            >
              {detail}
            </Typography>
          )}
          {children}
        </>
      )}
    </Box>
  );
}
